// Components
import { StepMediaVideoTranscriptionComponent } from './step-media-video-transcription.component';

// Models
import { MediaUploadFlowStep } from '../../../../../../shared/_model/flow.model';

export const STEP_MEDIA_VIDEO_TRANSCRIPTION = {
  stepIdentifier: 'mediaUploadFlowStepVideoTranscription',
  identifier: 'uploadVideoTranscription',
  component: StepMediaVideoTranscriptionComponent,
  name: 'Transcription',
  title: 'Verify your transcription',
  subtitle: 'Check that the transcription is correct and edit it if required',
  header: true,
  headerDistinctive: true,
  displayInFlowProgressBar: true,
  canNavigateBack: false,
} as MediaUploadFlowStep;
